var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8466",
    "data-name": "Group 8466",
    transform: "translate(0 -0.036)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 20,
    height: 20,
    transform: "translate(0 0.036)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(1.571 3.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(3.913 1.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M1732.519,502.462l.357.048a2.512,2.512,0,0,1,2.205,2.1,2.481,2.481,0,0,1-.547,2.114,2.3,2.3,0,0,1-1.389.761,2.851,2.851,0,0,1-2.082-.436,2.28,2.28,0,0,1-1.075-1.635,2.542,2.542,0,0,1,1.4-2.709,2.464,2.464,0,0,1,.9-.215.885.885,0,0,0,.136-.027Z",
    transform: "translate(-1727.952 -502.462)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    d: "M4.589,0h0A4.589,4.589,0,0,1,9.179,4.589V6.414a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4.589A4.589,4.589,0,0,1,4.589,0Z",
    transform: "translate(0 5.901)",
    fill: "#5475c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M1707.534,494.684l.246.033a1.735,1.735,0,0,1,1.524,1.45,1.714,1.714,0,0,1-.378,1.461,1.588,1.588,0,0,1-.959.525,1.97,1.97,0,0,1-1.438-.3,1.574,1.574,0,0,1-.743-1.129,1.756,1.756,0,0,1,.965-1.872,1.7,1.7,0,0,1,.62-.149.6.6,0,0,0,.094-.018Z",
    transform: "translate(-1704.379 -494.684)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M1704.51,518.53a3.172,3.172,0,0,0-2.981-2.09h0a3.171,3.171,0,0,0-3.171,3.171v1.261h3.412A3.746,3.746,0,0,1,1704.51,518.53Z",
    transform: "translate(-1698.357 -512.363)",
    fill: "#5475c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(10.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M1764.48,494.684l-.246.033a1.735,1.735,0,0,0-1.524,1.45,1.714,1.714,0,0,0,.378,1.461,1.589,1.589,0,0,0,.959.525,1.971,1.971,0,0,0,1.439-.3,1.575,1.575,0,0,0,.743-1.129,1.757,1.757,0,0,0-.965-1.872,1.7,1.7,0,0,0-.62-.149.6.6,0,0,1-.094-.018Z",
    transform: "translate(-1761.483 -494.684)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M1756.282,518.53a3.172,3.172,0,0,1,2.982-2.09h0a3.171,3.171,0,0,1,3.171,3.171v1.261h-3.411A3.745,3.745,0,0,0,1756.282,518.53Z",
    transform: "translate(-1756.282 -512.363)",
    fill: "#5475c2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorCustomer);
export default __webpack_public_path__ + "static/media/color_customer.a1d66794068592574ed0ff57c39a5e3c.svg";
export { ForwardRef as ReactComponent };